var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":_vm.computedColor,"dark":"","small":""}},[_vm._v(" "+_vm._s(_vm._f("requestStatus")(_vm.data.status))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }